import { NgModule } from '@angular/core';
import { GroupComponent } from './group.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { CommonModule } from '@angular/common';

import { NavigationModule } from '../sales-center-navigation/navigation.module';
import { MeetingSchedulerSharedModule } from '../shared/meeting-scheduler-shared.module';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyStickyFooterModule } from '@vendasta/galaxy/sticky-footer';
import { MeetingSchedulerSettingsModule } from '../schedule-settings/schedule-settings.module';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { GalaxyButtonLoadingIndicatorModule } from '@vendasta/galaxy/button-loading-indicator';
import { EventTypePipe } from '../shared/event-type.pipe';

@NgModule({
  declarations: [GroupComponent],
  imports: [
    TranslateModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    MatExpansionModule,
    MatDialogModule,
    DragDropModule,
    MatCardModule,
    MatIconModule,
    MatCheckboxModule,
    MatFormFieldModule,
    GalaxyTooltipModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    GalaxyButtonLoadingIndicatorModule,
    MatButtonToggleModule,
    MeetingSchedulerSharedModule,
    NavigationModule,
    CommonModule,
    MatSlideToggleModule,
    MatDividerModule,
    GalaxyFormFieldModule,
    GalaxyStickyFooterModule,
    MeetingSchedulerSettingsModule,
    MatRadioGroup,
    MatRadioButton,
    GalaxyBadgeModule,
    EventTypePipe,
  ],
  providers: [],
})
export class GroupModule {}
